


































































import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import FileUploadMixin from '@/components/mixins/FileUploadMixin.vue';
import { CoverLetter } from '@/../gen';

export interface FormDataInterface {
  title: string;
  content: string;
}

export default mixins(FileUploadMixin, E2EMixin).extend({
  mixins: [FileUploadMixin],
  props: {
    coverLetter: {
      type: Object as PropType<CoverLetter>,
      default: () => ({ title: null, content: null }),
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        title: this.coverLetter.title,
        content: this.coverLetter.content,
      } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
